"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
require("../index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _index2 = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    CourseItem: _courseItem.default
  },
  // <!--------------------------- 教师能力提升中心ye --------------------------->
  data: function data() {
    return {
      imgBanner: require("../../../assets/img/image/topbg.png"),
      menusList: [{
        tit: '课程分类',
        itemList: [{
          "name": '全部'
        }, {
          "name": "实训课程"
        }, {
          "name": "教师培训课程"
        }, {
          "name": "党的理论与教育政策培训"
        }, {
          "name": "职业教育教师学科教学培训"
        }, {
          "name": "职业教育教师素质能力提升培训"
        }, {
          "name": "职业教育新手教师培训"
        }, {
          "name": "职业院校校长培训"
        }],
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '年份',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wYearListAll)),
        actheight: false,
        act: 0,
        isZhan: false
      }],
      query: {
        courseName: "",
        courseSource: "",
        pageNum: 1,
        pageSize: 20,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        courseType: '8',
        courseConType: "",
        schoolId: '',
        showStatus: 1,
        year: ""
      },
      list: [],
      total: 0,
      loading: false
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      console.log('dianji', e);
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getList();
    },
    chooseList: function chooseList(e) {
      console.log('dianji', e);
      if (e[0] == '课程分类') {
        if (e[1].name == '全部') {
          this.query.courseConType = '';
        } else {
          this.query.courseConType = e[1].name;
        }
      } else if (e[0] == '年份') {
        if (e[1].name == '全部') {
          this.query.year = '';
        } else {
          this.query.year = e[1].name;
        }
      }
      this.query.pageNum = 1;
      this.getList();
    },
    // 获取课程
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 1;
              return (0, _index2.getReceptionList)(this.query);
            case 1:
              res = _context.sent;
              if (res.code == 200) {
                this.list = res.rows;
                this.total = res.total;
                this.loading = false;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getList();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return this.getList();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};